(() => {
  const links = [...document.querySelectorAll('[data-ab-cart-link]')];
  if (!links.length || links[0].dataset.initialized) return;
  links[0].dataset.initialized = 'true';
  let pending = false;
  const show = count => {
    if (!Number.isFinite(count)) return;
    links.forEach(link => {
      link.querySelector('[data-ab-cart-count]').textContent = String(count);
      link.setAttribute('aria-label', link.dataset.abCartLabel.replace('[count]', count));
    });
  };
  const refresh = async () => {
    if (pending || document.hidden) return;
    pending = true;
    try {
      const response = await fetch(links[0].dataset.abCartUrl, {credentials:'same-origin',cache:'no-store'});
      if (response.ok) show(Number((await response.json()).item_count));
    } catch (_) {} finally { pending = false; }
  };
  const bus = window.theme?.pubsub;
  if (bus?.subscribe && bus.PUB_SUB_EVENTS?.cartUpdate) {
    bus.subscribe(bus.PUB_SUB_EVENTS.cartUpdate, event => {
      if (Number.isFinite(event?.cart?.item_count)) show(event.cart.item_count);
      else refresh();
    });
  }
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  refresh();
})();
